import { IMAGES } from './images'

export const SERVICES_CONTENT = {
  title: 'Services',
  intro: 'Integrated pest management programs for grain, logistics, warehousing, food processing, and port operations across Texas.',
  heroImage: IMAGES.services,
  columns: [
    {
      title: 'Grain Services',
      image: IMAGES.grainHandling,
      text: 'Our fumigation and pest management services offer a comprehensive solution to safeguard your harvest. With expertise in pest management, we ensure grain remains free from infestations, protecting your investment and reputation. Our tailored approach considers your specific needs and the unique challenges of your operation, employing state-of-the-art techniques and environmentally responsible products. We also provide services for organic food products, protecting commodities throughout the entire process.',
    },
    {
      title: 'Logistics & Warehousing Services',
      image: IMAGES.warehousing,
      text: 'Pests and infestations causing disruptions to your logistics and warehousing operations? Our comprehensive fumigation, sanitation, and pest management services are tailored to keep your facilities running smoothly. We eliminate existing pest problems and implement preventive measures to ensure they do not return. Partner with us to safeguard your inventory, protect your reputation, and maintain compliance with industry regulations.',
    },
    {
      title: 'Port & Compliance Services',
      image: IMAGES.portServices,
      text: 'We proudly serve the Port of Houston and all other Texas ports of entry for compliance needs including safeguarding, fumigation, cleaning, and removal. Our certified specialists have been working side by side with USDA and Customs for over 25 years. Received an emergency action notice? Call us right away to address those needs and prevent further fines. We are your 24/7 service provider.',
    },
  ],
}
